const Title = (props) => {
  const { title, className } = props;

  return (
    <div className={`text-green-400 font-extrabold md:text-6xl -tracking-[1.28px] text-[32px] md:leading-[64px] leading-[32px] ${className}`}>{title}</div>
  )
};

export default Title;